export const bzPartners = {
    "event": {
        "exhibitorsTypes": [
            {
                "name": "host-partner",
                "id": "RmllbGRWYWx1ZV8yMzkwMTI2Ng==",
                "position": 0
            },
            {
                "name": "Host Sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                "position": 0
            },
            {
                "name": "strategic-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "position": 0
            },
            {
                "name": "founding-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1Mg==",
                "position": 0
            },
            {
                "name": "enablement-partner",
                "id": "RmllbGRWYWx1ZV8yMjM5NDE0OQ==",
                "position": 0
            },
            {
                "name": "country-pavilion-sponsors",
                "id": "RmllbGRWYWx1ZV8yMTM5MzcxMQ==",
                "position": 0
            },
            {
                "name": "platinum-sponsors",
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "position": 0
            },
            {
                "name": "pavilion-sponosr",
                "id": "RmllbGRWYWx1ZV8yMzk0MjEyNQ==",
                "position": 0
            },
            {
                "name": "emerald-sponsor",
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "position": 0
            },
            {
                "name": "Gold Sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "position": 0
            },
            {
                "name": "Silver Sponsors",
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "position": 0
            },
            {
                "name": "grif-platinum-sponsor",
                "id": "RmllbGRWYWx1ZV8yMjcxMTI3Ng==",
                "position": 0
            },
            {
                "name": "grif-exhibitor",
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3OQ==",
                "position": 0
            },
            {
                "name": "Strategic Partner",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMQ==",
                "position": 0
            },
            {
                "name": "start-up-exhibitor",
                "id": "RmllbGRWYWx1ZV8yMzEwNjg2Mw==",
                "position": 0
            },
            {
                "name": "un-tourism-innovation-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzA4MTIwMA==",
                "position": 0
            },
            {
                "name": "coffee-sponsor",
                "id": "RmllbGRWYWx1ZV8xNTAzNDczNw==",
                "position": 0
            },
            {
                "name": "water-station-sponsor",
                "id": "RmllbGRWYWx1ZV8yNDE1NjE5Nw==",
                "position": 0
            },
            {
                "name": "after-party-host",
                "id": "RmllbGRWYWx1ZV8yMjQ0MjEzMw==",
                "position": 0
            },
            {
                "name": "confectionary-cafe-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA3OQ==",
                "position": 0
            },
            {
                "name": "refreshment-bar-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4MA==",
                "position": 0
            },
            {
                "name": "mini-golf-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzk0Mjg1Ng==",
                "position": 0
            },
            {
                "name": "clinic-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4Mg==",
                "position": 0
            },
            {
                "name": "networking-sponsor",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4Mw==",
                "position": 0
            },
            {
                "name": "official-carriers",
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4NA==",
                "position": 0
            },
            {
                "name": "media-partner",
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "position": 0
            },
            {
                "name": "supporter",
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "position": 0
            },
            {
                "name": "culinary-and-concept-tour-partners",
                "id": "RmllbGRWYWx1ZV8yMDc3MjE1MQ==",
                "position": 0
            },
            {
                "name": "Organiser",
                "id": "RmllbGRWYWx1ZV8xNTAzNDc1NQ==",
                "position": 0
            }
        ]
    },
    "exhibitors": [
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzE=",
            "name": "Hilton",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/4950663b82304c41b0f1265679f56640.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzI=",
            "name": "Wyndham Hotels & Resorts",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/d8f0924ea9164f218a5475faabf39906.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzM=",
            "name": "Minor Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/20354d1296ac462c9bbad94c60569581.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzQ=",
            "name": "QUO",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e78a6bd0f5c440889388c5057bf38508.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzU=",
            "name": "Rove Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/d2c1487560c3423fb490d96cb471da87.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzY=",
            "name": "IHCL",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/57a3cd54a7b04558baf5aa653c5a1cb2.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzc=",
            "name": "HVS",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/9352265026bf4ccfab49a005b1b8e1cc.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzg=",
            "name": "LEVA Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/6743b3f7874745209fae69e3eea23108.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczMzk=",
            "name": "Knight Frank",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/97feda61a94243d0a0fd429d35d0a94f.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDA=",
            "name": "Aleph Hospitality",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/997d458c00fb4e458857a94e384ff447.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDE=",
            "name": "Millennium Hotels & Resorts",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/0728d4210bc541b8b59a11aca8823df4.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDI=",
            "name": "Marriott",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/030ebd0651d548a3945c86f06d3fc051.jpeg",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDM=",
            "name": "Radisson Hotel Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e681d499cbfb4506aef54274593df93e.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDQ=",
            "name": "Rotana Hotels and Resorts",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/6840f7b93d9a473da7f0b64676f6215a.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDU=",
            "name": "NEOM",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/02f00839db2b4b5c87f2596c203ea173.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDY=",
            "name": "Club Med",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/20184dd0a58a43efa904436e2e309e81.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDc=",
            "name": "Time Hotels",
            "logoUrl": "https://static.swapcard.com/public/images/ee686b571aff4903928a08ef0e562e04.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1MzczNDg=",
            "name": "STR",
            "logoUrl": "https://static.swapcard.com/public/images/b3a41983859c49838d74a787d1c65c46.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NzM4MjU=",
            "name": "Italia Hospitality",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/821abfafd09344a5a5997614cf16e2f6.png",
            "type": "Country Pavilions",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMTM5MzcxMQ==",
                "name": "country-pavilion-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NzM4MzE=",
            "name": "The Emirates Academy of Hospitality Management",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/d002c32338d14fc29e81a0b99e1b2802.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NzU5MjA=",
            "name": "Taiba Investments",
            "logoUrl": "https://static.swapcard.com/public/images/537e3c64fe50469cbcfe083a8768fae0.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1NzcyMTk=",
            "name": "Barrière Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/17a1c24165f3410b9cbbcba4b88aced8.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1Nzc0OTE=",
            "name": "Louvre Hotels Group",
            "logoUrl": "https://static.swapcard.com/public/images/c42150fc950c4aba8e9733c1fed8d9db.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1Nzk3NjA=",
            "name": "United Hospitality Management",
            "logoUrl": "https://static.swapcard.com/public/images/d3056cfc456c4b96b180466b98ef76b5.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1ODA3NTM=",
            "name": "CBRE",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/18ae45225abb4e8e9751b4db2753f127.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1ODc2OTc=",
            "name": "HAMA",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/65afec061c20477c87703e2642113412.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1ODc3OTc=",
            "name": "Moroccan Agency for Tourism Development - SMIT",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/cac8531b7c5f49898ba73b9a9693985d.png",
            "type": "Country Pavilions",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMTM5MzcxMQ==",
                "name": "country-pavilion-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTI0MzQ=",
            "name": "World Sustainable Hospitality Alliance",
            "logoUrl": "https://static.swapcard.com/public/images/788ac3f87a95412e976d3dd6b5b34af7.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE1OTI0MzU=",
            "name": "Sustainable Hospitality Challenge",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/12027a59c8ca435ab33631c1ac2caade.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MDEyMjQ=",
            "name": "Aldar",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/f083839f004d4613bb04fedf92705b26.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MDI1MTc=",
            "name": "EHL Hospitality Business School",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/738142370e9f44ea9f0cdfa7d35a6cbf.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTExMDk=",
            "name": "H World International",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/500f0da5fa7e486f9044de5ff094348c.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTEyMDQ=",
            "name": "The Ascott Limited",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/b8d20d42ca20464c8db6b8d5f2f2c6e9.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTMyOTc=",
            "name": "Elaf Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/8eba5d9a4f7245ff9a6905c502ddc2e3.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTQzMDQ=",
            "name": "Jumeirah",
            "logoUrl": "https://static.swapcard.com/public/images/55ed5bb8a595429fb7fc70e2690e446f.png",
            "type": "Host Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                "name": "Host Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MTQzNjc=",
            "name": "Foresite Creative",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/9ea6166e99794eacb6b44a5893fa2ffc.png",
            "type": "Data Partner - Restaurant Invest",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMQ==",
                "name": "Strategic Partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjAyMTU=",
            "name": "IHG",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/7801e395c6394b8a9893c1596a0050ed.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjA2MDk=",
            "name": "Accor",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/fa644ca3c739455088ab2f9a34909cc7.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjA2ODU=",
            "name": "JT+Partners",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/61e842d9ab6643c9902bcf166fc13325.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MjIyODU=",
            "name": "Adyen",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/493386e116404d65b623dcf5f22a4501.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2Mjc1NjI=",
            "name": "Rikas Hospitality Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e3c6ad372c434387a2dfac91e96ec8aa.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MzA1NjI=",
            "name": "UN Tourism",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/9f6e276391d24bc4ad29b4e3205b2bdf.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2MzI4ODI=",
            "name": "ARC International Design Consultants",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/21ed0eb0d4ab4f40872ff69f200ca77e.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjM2Nzk=",
            "name": "Hozpitality",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/5298cbc6b7ad4cc39080ed0603d5425e.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjQ0MDg=",
            "name": "Tui Hotels & Resorts",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/393e466876004c08a2e21a5b0f635739.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjQ0MjE=",
            "name": "Lokalee",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/319ee5866a6e4375b83f10a842dad6ff.png",
            "type": "Start-up Exhibitor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzEwNjg2Mw==",
                "name": "start-up-exhibitor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjQ4OTU=",
            "name": "Compass Project Consulting",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/b3361afa0c7b42f39f36db218b7cfd0d.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjY0MjM=",
            "name": "Action Hotels",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/3b6a3dffe3cf4c76a5babc55c739c4b5.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjY0MjU=",
            "name": "Hyatt",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/500f7980ceb844e9aa7f3a07ef329efd.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2NjcwODQ=",
            "name": "Colliers",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/95e4ccb6b5ff4fbc9229693623586d18.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE2OTU3ODk=",
            "name": "Red Sea Global",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/5715dc5ef8a2467e96f2ff49e1ab4a13.png",
            "type": "Emerald Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMDg1NjkwMg==",
                "name": "emerald-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE3MDk1NTY=",
            "name": "New Murabba",
            "logoUrl": "https://static.swapcard.com/public/images/9297747fd3974255b3111e5c5e5fa4c7.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE3ODMzNjk=",
            "name": "Maldives Fund Management Corporation (MFMC)",
            "logoUrl": "https://static.swapcard.com/public/images/0e55e47124344062b67ab94f2ed68336.png",
            "type": "Country Pavilions",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMTM5MzcxMQ==",
                "name": "country-pavilion-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE3OTQzNzk=",
            "name": "ARK People Solutions",
            "logoUrl": "https://static.swapcard.com/public/images/047f55dacb7a4ca882bfa00fadd9735d.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE3OTk0MTE=",
            "name": "Shaza Hotels",
            "logoUrl": "https://static.swapcard.com/public/images/7531f54bcfd24a47af4833191968f34f.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MDA4MDI=",
            "name": "Enterprise Greece",
            "logoUrl": "https://static.swapcard.com/public/images/d05be9e47cd848f4add349ca29c4a264.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MDg4NjM=",
            "name": "Kearney",
            "logoUrl": "https://static.swapcard.com/public/images/de5419a14c854ac8885c60f7e83bf0aa.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4NzU=",
            "name": "TTN Worldwide",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/ebccd32f013e41c7a959fae80021bc5b.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4NzY=",
            "name": "Hospitality News Middle East",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/5188903ac2bb4219ab9e9a306dcb4f05.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4Nzc=",
            "name": "Connecting Travel",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/b0a6c08465934496ac0cbf095ec1ef30.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4Nzg=",
            "name": "Arab News",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/2ec375339d2849a2ac36f01e2acfe7fc.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4Nzk=",
            "name": "Oxford Business Group",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/1d38279e6a4545738132a21a73f5526e.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4ODA=",
            "name": "CNN Business Arabic",
            "logoUrl": "https://cdn-api.swapcard.com/public/images/e871d598f1d14e69a83b53e2ca280755.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4ODY=",
            "name": "Breaking Travel News",
            "logoUrl": "https://static.swapcard.com/public/images/2a72adeac34c4a318aecebbb4f36cc3e.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4MTI4ODc=",
            "name": "Eye of Riyadh",
            "logoUrl": "https://static.swapcard.com/public/images/41f5f291e91848e5a99abca30295af5b.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4Mjc1NDE=",
            "name": "Unox MENA",
            "logoUrl": "https://static.swapcard.com/public/images/edf3544d18ab44de8361d438ee664736.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NDMxMDc=",
            "name": "BE WTR",
            "logoUrl": "https://static.swapcard.com/public/images/c8a4375d754b4aed99e6e07a0bf5fd29.png",
            "type": "Water Station Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yNDE1NjE5Nw==",
                "name": "water-station-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NDMxMTg=",
            "name": "Conran Design Group",
            "logoUrl": "https://static.swapcard.com/public/images/a3a07e30c1734a19b1b74a04fe5e9862.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NDMxNDM=",
            "name": "UAE Restaurants Group",
            "logoUrl": "https://static.swapcard.com/public/images/45aed051638c438882c2c484149fcf0b.jpeg",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NDU5OTI=",
            "name": "Emaar Hospitality Group",
            "logoUrl": "https://static.swapcard.com/public/images/42621b2fb1ec477a8d71911c4fc41be5.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NDkyODI=",
            "name": "COREcruitment",
            "logoUrl": "https://static.swapcard.com/public/images/af501c225be443f189d4a9627f4856c8.png",
            "type": "Coffee Sponsor",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczNw==",
                "name": "coffee-sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NTA2MTI=",
            "name": "JLL",
            "logoUrl": "https://static.swapcard.com/public/images/2b315d592ba7495096b28ceead18c69b.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NTQ4OTM=",
            "name": "The Emirates Culinary Guild",
            "logoUrl": "https://static.swapcard.com/public/images/b6ea5d69571d46779fa90f416cbf363a.jpeg",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NjM3Mjc=",
            "name": "Sharjah Investment and Development Authority (Shurooq)",
            "logoUrl": "https://static.swapcard.com/public/images/94d52a1c5de04e0cafbbecb2075e1993.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NzA4MzQ=",
            "name": "Considerate Group",
            "logoUrl": "https://static.swapcard.com/public/images/c1ed8aeaf36b4755979bcf768e3171a0.jpeg",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4NzMwNDY=",
            "name": "Dusit International",
            "logoUrl": "https://static.swapcard.com/public/images/8da31e7f7ff74334a3eaab0a41f4e9c3.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4ODU4NjM=",
            "name": "Cavendish Maxwell",
            "logoUrl": "https://static.swapcard.com/public/images/ac81883e30d94c6cbf5a251d164ae5f1.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4ODU4NzE=",
            "name": "roboSculptor",
            "logoUrl": "https://static.swapcard.com/public/images/72b886cbe62744a492b1e51ff4b60212.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4ODU5MDU=",
            "name": "Sri Lanka Tourism Development Authority",
            "logoUrl": "https://static.swapcard.com/public/images/4bbdccdaa4644433860b01e7fe5cd027.png",
            "type": "Country Pavilions",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMTM5MzcxMQ==",
                "name": "country-pavilion-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4OTI5ODA=",
            "name": "Livit Consulting & Design",
            "logoUrl": "https://static.swapcard.com/public/images/f477fcb0860046e882f97cc879d154e7.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4OTQ1ODg=",
            "name": "Prologic First Software",
            "logoUrl": "https://static.swapcard.com/public/images/8696df97b0a541348ba20e187464144f.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4OTcxODI=",
            "name": "Compagnie Hoteliere et Immobiliere du Congo (CHIC)",
            "logoUrl": "https://static.swapcard.com/public/images/c1f834d8185f43e7bc4a53cdbfcfea38.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4OTgxMjQ=",
            "name": "AtkinsRéalis",
            "logoUrl": "https://static.swapcard.com/public/images/daf944a18899450eaaf097e3c9b85789.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE4OTgxMjg=",
            "name": "PwC",
            "logoUrl": "https://static.swapcard.com/public/images/a8db1ba0fe2248a282462aa08b321c30.jpeg",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MDQ0ODQ=",
            "name": "Skyline University College",
            "logoUrl": "https://static.swapcard.com/public/images/ae4e52478e7d4394b50ff9d731ba4b55.jpeg",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MDQ5NzE=",
            "name": "Les Roches Abu Dhabi",
            "logoUrl": "https://static.swapcard.com/public/images/c907fb4fe3674c479faa8fdd36764f3b.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MDU2MTY=",
            "name": "Asfar",
            "logoUrl": "https://static.swapcard.com/public/images/0b0e01a790e243d6a172c59ddf121242.png",
            "type": "Gold Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczMg==",
                "name": "Gold Sponsor"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MDgwNjg=",
            "name": "TravTalk",
            "logoUrl": "https://static.swapcard.com/public/images/205df670661a46bba3b9c7586d40d5f0.jpeg",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MzAwMzc=",
            "name": "Studiomint Design Group",
            "logoUrl": "https://static.swapcard.com/public/images/68a4e23f858047c19c6da22072d92a98.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MzAwOTI=",
            "name": "The Summary Executive Properties L.L.C",
            "logoUrl": "https://static.swapcard.com/public/images/891fe4579e01409397334e89321ca4dc.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MzMzNjA=",
            "name": "X-Golf Middle East",
            "logoUrl": "https://static.swapcard.com/public/images/fc3b7f127c2b46e4bf8dbd7a545b191e.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5Mzc5OTg=",
            "name": "Sunset Hospitality Group",
            "logoUrl": "https://static.swapcard.com/public/images/41523643bff640ceb96d06461aefdb63.png",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5MzgwMTM=",
            "name": "Aimbridge Hospitality",
            "logoUrl": "https://static.swapcard.com/public/images/4cf716d2076747aa9ef9424c9fb05dcb.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NDIzNjQ=",
            "name": "Integrator Media",
            "logoUrl": "https://static.swapcard.com/public/images/2b241c712395448a81c2021597f236fe.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NDIzNzA=",
            "name": "Hospitality Integrator",
            "logoUrl": "https://static.swapcard.com/public/images/4fecf6b719a04949895bc2b04e4001ca.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NDIzNzE=",
            "name": "Katch",
            "logoUrl": "https://static.swapcard.com/public/images/3eb225da7692487b8eae6bf12589577b.jpeg",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NDQ3MTg=",
            "name": "Think Hospitality",
            "logoUrl": "https://static.swapcard.com/public/images/5ec17ec6a5bd42c3944aad93acfe03eb.png",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NDcxNjY=",
            "name": "Aseer Development Authority ",
            "logoUrl": "https://static.swapcard.com/public/images/49f93dac292f4290889955c32eff13eb.png",
            "type": "Platinum Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8yMzkzMjA4Mw==",
                "name": "platinum-sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NTQwMzc=",
            "name": "Gharieni Group",
            "logoUrl": "https://static.swapcard.com/public/images/e6eef2f73c434e57b54149769095d1c1.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NTQ5OTg=",
            "name": "MAWD | March and White Design",
            "logoUrl": "https://static.swapcard.com/public/images/1345af36ca7e4ec0ac8671f6801dd3b4.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NTkzMjU=",
            "name": "Finance World Magazine",
            "logoUrl": "https://static.swapcard.com/public/images/ee702ea208d84029a5c586f68f904291.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NTkzMzI=",
            "name": "Entrepreneur ME",
            "logoUrl": "https://static.swapcard.com/public/images/0789c342f46841b09ec56c79f6ab9cfc.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NTkzMzM=",
            "name": "Hotel & Catering",
            "logoUrl": "https://static.swapcard.com/public/images/c73cbc0f48ec4b0897ab3fce843e7d99.png",
            "type": "Media Partners",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "name": "media-partner"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NzEzMTY=",
            "name": "Turkish Tourism Investors Association",
            "logoUrl": "https://static.swapcard.com/public/images/299cce2e3c85485184a06e218b8d5fbe.jpeg",
            "type": "Supporters",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "name": "supporter"
            }
        },
        {
            "id": "RXhoaWJpdG9yXzE5NzYwNDc=",
            "name": "VX Studio / Ayana Holding",
            "logoUrl": "https://static.swapcard.com/public/images/d00b1995ed544a7cbcba607233e654fd.jpeg",
            "type": "Silver Sponsors",
            "typeLabel": {
                "id": "RmllbGRWYWx1ZV8xNTAzNDcyNw==",
                "name": "Silver Sponsors"
            }
        }
    ]
}